var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.dialogVisible, width: "80%", center: "" },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("span", [_vm._v("可导未导订单")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                plain: "",
                type: "success",
                icon: "el-icon-download",
                loading: _vm.exporting,
              },
              on: { click: _vm.onExport },
            },
            [_vm._v("\n            导出\n        ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "max-height": "600",
            border: "",
            "header-cell-style": { backgroundColor: "#f8faff" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "order_id", label: "订单号", "min-width": "220" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "product_id",
              label: "产品ID",
              "min-width": "200",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { property: "app_id", label: "APP ID", "min-width": "100" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { property: "channel", label: "渠道号", "min-width": "200" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "daofen_department",
              label: "导粉部门",
              "min-width": "150",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { property: "created_at", label: "下单时间", width: "180" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }